import { lazy } from 'react'
import type { Routes } from '@/types/routes'

const authRoute: Routes = [
    {
        key: 'signIn',
        path: `/sign-in`,
        component: lazy(() => import('@/features/base/user-management/auth/pages/SignIn')),
        authority: [],
    },
    {
        key: 'signUp',
        path: `/sign-up`,
        component: lazy(() => import('@/features/base/user-management/auth/pages/SignUp')),
        authority: [],
    },
    {
        key: 'forgotPassword',
        path: `/forgot-password`,
        component: lazy(() => import('@/features/base/user-management/auth/pages/ForgotPassword')),
        authority: [],
    },
    {
        key: 'resetPassword',
        path: `/reset-password`,
        component: lazy(() => import('@/features/base/user-management/auth/pages/ResetPassword')),
        authority: [],
    },
]

export default authRoute
